module.exports = __webpack_public_path__ + "img/cucumber.6a16867d.png";